// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"b7caf506","280":"6f61ae80","386":"9373e667","805":"eff183fe","945":"c7b184f7"}[chunkId] + ".chunk.js";
};